import React, { useState } from "react";

import styles from "./SignInCard.module.css";

import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import Card from "./Card";
import ButtonSignIn from "./Buttons/ButtonSignIn";
import LoadingSpinner from "./LoadingSpinner";
import { Link, useNavigate } from "react-router-dom";

const SignInCard = function (props) {
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const emailChangeHandler = function (e) {
    setUserEmail(e.target.value);
    setError(null);
  };

  const passwordChangeHandler = function (e) {
    setUserPassword(e.target.value);
    setError(null);
  };

  // Authentication
  const signInHandler = async function (e) {
    console.log("ATTEMTPING TO SIGN IN");
    e.preventDefault();
    setIsLoading(true);

    try {
      await signInWithEmailAndPassword(auth, userEmail, userPassword);
      navigate("/");
    } catch (err) {
      // TODO: HANDLE DIFFERENT TYPES OF ERRORS
      setError(err);
      console.log(err);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <div className={styles.container}>
      <Card className={styles["login-card"]}>
        <div className={styles["login-title-container"]}>
          {!isLoading && <h2 className={styles["login-title"]}>Welcome!</h2>}
          {isLoading && <LoadingSpinner />}
        </div>
        <form
          className={styles["login-form"]}
          onSubmit={signInHandler}
          autoComplete="off"
        >
          <label className={styles["login-label"]} htmlFor="email">
            Email
          </label>
          <input
            className={styles["login-input"]}
            id="email"
            type="email"
            value={userEmail}
            onChange={emailChangeHandler}
            required
          />
          <label className={styles["login-label"]} htmlFor="password">
            Password
          </label>
          <input
            className={styles["login-input"]}
            id="password"
            type="password"
            value={userPassword}
            onChange={passwordChangeHandler}
            required
          />
          {error && (
            <p className={styles.error}>Invalid user name or password.</p>
          )}
          <ButtonSignIn className={styles["login-btn"]} />
          <Link className={styles.signup} to="/signup">
            Sign up
          </Link>
        </form>
      </Card>
    </div>
  );
};

export default SignInCard;
